import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#F89A1C',
				secondary: '#CCCCCC',
				accent: '#F89A1C',
			},
		},
	},
});
